import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO
Vue.prototype.$marketing_configs = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      cadastro: {
        mktAddEdit: "new",
        id_marketing: "",
        loading: false,
        chaveAnalytics: "",
        imagem: "",
        error: { imagem: [] },
        banner: { imagem: null },
        imagens_array: [],
        loading_imagem: false,
      },
    };
  },

  methods: {
    // ---- LISTAR CONFIGURAÇÃO DE MARKETING ---- //
    getMktConfigs() {
      this.$axios.get(this.ENDPOINTS.GET_MKT_CONFIGS).then(response => {
        if (response.idmarketing) {
          this.cadastro.mktAddEdit = "edit";
          this.cadastro.chaveAnalytics = response.analytics_key;

          if (response.banners_publi_imply) {
            const arrayOfObj = Object.entries(response.banners_publi_imply).map(
              e => ({ [e[0]]: e[1] })
            );

            this.cadastro.imagens_array = arrayOfObj;
          }

          this.cadastro.id_marketing = response.idmarketing;
        } else {
          this.cadastro.mktAddEdit = "new";
        }
      });
    },

    // ---- ALTERAR CONFIGURAÇÃO DE MARKETING ---- //
    alterarMktConfig() {
      this.cadastro.loading = true;

      let imagens = {};
      this.cadastro.imagens_array.forEach(item => {
        imagens[Object.keys(item)] = Object.values(item)[0];
      });

      let dados = {
        analytics_key: this.cadastro.chaveAnalytics,
        banners_publi_imply: JSON.stringify(imagens),
      };

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_CONFIGS_MARKETING + this.cadastro.id_marketing,
          dados
        )
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditMktConfig", true);
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- CADASTRAR CONFIGURAÇÃO DE MARKETING ---- //
    async cadastrarMktConfig() {
      this.cadastro.loading = true;

      let imagens = {};
      this.cadastro.imagens_array.forEach(item => {
        imagens[Object.keys(item)] = Object.values(item)[0];
      });

      let dados = {
        analytics_key: this.cadastro.chaveAnalytics,
        banners_publi_imply: JSON.stringify(imagens),
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_CONFIGS_MARKETING, dados)
        .then(response => {
          if (response) {
            // dados cadastrais
            (this.cadastro.chaveAnalytics = ""),
              (this.cadastro.banner.imagem = "");
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro() {
      if (this.cadastro.mktAddEdit == "edit") {
        this.alterarMktConfig();
        return;
      }

      this.cadastrarMktConfig();
    },
  },
});
